import { Check, Copy } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import useCopyToClipboard from '@/utils/useCopyToClipboard.ts';

import Button, { type ButtonProps } from './Button.tsx';

export interface CopyButtonProps extends Pick<ButtonProps, 'size' | 'className'> {
    value: string;
    // Without it, the button sits in a line of text, e.g. a page's subtitle, so it's only its icon.
    hasLabel?: boolean;
}

// Copies the value, and says so for a moment.
const CopyButton = ({ value, hasLabel = true, ...props }: CopyButtonProps) => {
    const { t } = useTranslation();
    const { isCopied, copy } = useCopyToClipboard();

    return (
        <Button
            {...props}
            variant={hasLabel ? 'muted' : 'ghost'}
            aria-label={hasLabel ? undefined : t('common.copy')}
            onClick={() => void copy(value)}
        >
            {isCopied ? <Check /> : <Copy />}
            {hasLabel && (isCopied ? t('common.copied') : t('common.copy'))}
        </Button>
    );
};

export default CopyButton;
